module.exports = __webpack_public_path__ + "img/plus.171abd52.svg";